import * as React from 'react';
import { FullMatchFragment } from '../../generated/graphql';
import { Container } from '../../components/Container';
import { Heading } from '../../components/Heading';
import { paths } from '../../paths';
import { InternalLink } from '../../components/InternalLink';
import { SharePageButton } from '../../components/SharePageButton';
import { getScoreInfo } from './utils';

interface Props {
  match: FullMatchFragment;
  reloadMatch: () => void;
}

export const MatchHeader: React.FC<Props> = ({ match, reloadMatch }) => {
  const { host, protocol } = window.location;
  const matchShareLink = `${protocol}//${host}${paths.match.home(match.id)}`;

  const { homeTeam, awayTeam } = getScoreInfo(match);

  return (
    <div className="bg-primary text-white -mt-6 py-6">
      <Container className="flex justify-between">
        <InternalLink to={paths.match.home(match.id)} onClick={reloadMatch}>
          <Heading level={1}>
            <span className={match.atHome ? 'text-xl' : 'text-4xl'}>
              {homeTeam} <span className="text-xl">vs</span>
            </span>{' '}
            <br />
            <span className={match.atHome ? 'text-4xl' : 'text-xl'}>
              {awayTeam}
            </span>
          </Heading>
        </InternalLink>
        <SharePageButton
          context="share_match"
          title="Share match"
          shareText={`${match.team.name} vs ${match.opponent} on Matchhaus`}
          url={matchShareLink}
        />
      </Container>
    </div>
  );
};
